export const calculateBmi = (height, weight) => {
    const heightInMeters = height / 100;
    const bmiValue = weight / (heightInMeters ** 2);
    return bmiValue.toFixed(2)
}